import { useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// RANKING: the respondent orders the answer options. The answer is
// [{ id, rank }], where id is the option id and rank its 1-based position.
const toResult = (items) => items.map((item, index) => ({ id: item.id, rank: index + 1 }));

// Restores the order from a saved answer (Back navigation); options missing
// from it keep their original order at the end.
const orderBySavedRanks = (items, savedResult) => {
  if (!Array.isArray(savedResult) || savedResult.length < 1) {
    return items;
  }
  const rankOf = (item) => savedResult.find(r => r.id === item.id)?.rank ?? Infinity;
  return [...items].sort((a, b) => rankOf(a) - rankOf(b));
};

const RankingInput = (props) => {
  const { id, typeName, order, options, input: { value, onChange } } = props;
  const [items, setItems] = useState([]);

  const emitChange = (ordered) => {
    onChange({ id, typeName, order, result: toResult(ordered) });
  };

  // Runs once on mount: the initial order is already a valid answer, so it is
  // written to redux-form right away (a required RANKING can be accepted as is).
  useEffect(() => {
    const rankable = (options || []).filter(o => o.typeName === 'OPTION');
    const ordered = orderBySavedRanks(rankable, value?.result);
    setItems(ordered);
    if (ordered.length > 0) {
      emitChange(ordered);
    }
  }, []);

  const move = (index, delta) => {
    const target = index + delta;
    if (target < 0 || target >= items.length) {
      return;
    }
    const ordered = [...items];
    [ordered[index], ordered[target]] = [ordered[target], ordered[index]];
    setItems(ordered);
    emitChange(ordered);
  };

  return (
    <List dense>
      {items.map((item, index) => (
        <ListItem
          key={item.id}
          divider
          secondaryAction={
            <>
              <IconButton
                aria-label="up"
                disabled={index === 0}
                onClick={() => move(index, -1)}
              >
                <KeyboardArrowUpIcon />
              </IconButton>
              <IconButton
                aria-label="down"
                disabled={index === items.length - 1}
                onClick={() => move(index, 1)}
              >
                <KeyboardArrowDownIcon />
              </IconButton>
            </>
          }
        >
          <ListItemText primary={`${index + 1}. ${item.label || ''}`} />
        </ListItem>
      ))}
    </List>
  );
};

export default RankingInput;
